<script lang="ts">
    import type {AuthorityDetailReactivePageData, AuthorityDetailStaticPageData} from '../types';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';

    const pageContext = getPageContext<AuthorityDetailStaticPageData, AuthorityDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

<div class="record-heading-container">
    <KpHeading type="h1">
        <div class="authority-name">{model.record.name}</div>
        <div class="authority-100abcd">{model.field100abcdValue}</div>
    </KpHeading>
</div>